import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { H6, H5 } from "../Html";
import { Icon } from "../Icon";
export const Button = (props) => {
  const {
    intent,
    icon,
    children,
    className,
    onClick,
    tertiary,
    disabled,
    text,
    small,
    large,
    minimal,
    type,
    active,
    ...otherProps
  } = props;
  const btnClassNames = () =>
    classNames(
      "at-button",
      {
        [`at-intent-${intent}`]: intent,
        "at-minimal": minimal,
        "at-disabled": disabled,
        "at-tertiary": tertiary,
        "at-small": small,
        "at-large": large,
        "at-active": active,
      },
      className
    );
  const textClassName = "at-button-text";
  return (
    <button type={type} disabled={disabled} className={btnClassNames()} onClick={onClick} {...otherProps}>
      {icon && <Icon icon={icon} />}
      {text &&
        (small ? (
          <p className={textClassName}>{text}</p>
        ) : large ? (
          <H5 className={textClassName}>{text}</H5>
        ) : (
          <H6 className={textClassName}>{text}</H6>
        ))}
      {children}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string,
  intent: PropTypes.oneOf([null, "primary", "warning", "danger"]),
  tertiary: PropTypes.bool,
  disabled: PropTypes.bool,
  minimal: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};
Button.defaultProps = {
  className: "",
  intent: null,
  tertiary: false,
  disabled: false,
  minimal: false,
  small: false,
  large: false,
};
